<template>
  <div>
    <v-sheet class="mt-2" v-if="loading">
      <v-skeleton-loader class="mx-auto" type="table-tbody"></v-skeleton-loader>
    </v-sheet>
    <v-simple-table v-else class="bordered--table elevation-5">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">#</th>
            <th class="text-left" v-for="group in listOfGroups" :key="group.id">{{ group.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in listOfPermission" :key="item.name">
            <td>{{ $t(item.text) }}</td>
            <td v-for="group in item.groups" :key="group.id">
              <v-checkbox hide-details v-model="group.has_permission" color="primary" @change="updatePermission(group.has_permission, group.id, item.id)" class="ma-0"></v-checkbox>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      loading: false,
      listOfPermission: [],
      MODULE_URL: 'permissions'
    }
  },
  computed: {
    ...mapState(['listOfGroups'])
  },
  created () {
    this.$store.dispatch('getGroups')
      .then(() => {
        this.getAllPermissions()
      })
  },
  methods: {
    getAllPermissions () {
      this.loading = true
      this.$_executeApi('get', this.MODULE_URL)
        .then((response) => {
          let allPermissions = response.data || []
          let permissions = this.$formatter.cloneVariable(this.$_PERMISSIONS_LIST)
          let groups = this.$formatter.cloneVariable(this.listOfGroups)
          permissions.map(x => {
            x['groups'] = groups.map(y => {
              let item = this.$formatter.cloneVariable(y)
              item['has_permission'] = !!allPermissions.find(p => p.permission_id === x.id && p.group_id === item.id)
              return item
            })
          })
          this.listOfPermission = permissions
        })
        .finally(() => {
          this.loading = false
        })
    },
    updatePermission (value, groupId, permissionId) {
      var method = value ? 'post' : 'delete'
      var text = value ? this.$t('message.common.updateMsg') : this.$t('message.common.deleteMsg')
      var color = value ? 'success' : 'error'
      var url = value ? this.MODULE_URL : `${this.MODULE_URL}?groupid=${groupId}&permissionid=${permissionId}`
      var permissonObj = {
        group_id: groupId,
        permission_id: permissionId
      }
      var model = value ? permissonObj : null
      this.$_executeApi(method, url, model)
        .then(res => {
          this.$root.$emit('snackbar', { snackbar: true, color: color, text })
        })
    }
  }
}
</script>
